import * as React from 'react';
import './App.css';
import Rap from './Rap';

class App extends React.Component {
  public render() {
    return (
      <div className="App">
      	<div className="About">
          <div id="logo">
            Quickverse
          </div>
      		<div id="feedback">
            <a href="https://www.youtube.com/results?search_query=freestyle+beats&sp=EgIIAw%253D%253D" target="_blank" rel="noopener noreferrer">Get a beat</a>
      			<a href="https://twitter.com/messages/compose?recipient_id=113719820" target="_blank" rel="noopener noreferrer">Share feedback</a>
      		</div>
      	</div>
        <div className="Rap">
          <Rap />
        </div>
      </div>
    );
  }
}

export default App;